import React from 'react'
import image from '../assets/images/transparentLogo.png'
import { PropTypes } from 'prop-types'
import 'src/scss/_loading.scss'

const Loading = (props) => {
  return (
    <div className="loadingContainer" data-isloading={props?.isLoading}>
      <div
        className=" d-grid m-auto"
        style={{
          backgroundColor: '#ffffff',
          padding: '15px',
          background: 'rgba(255, 255, 255, 0.22)',
          borderRadius: '16px',
          boxShadow: ' 0 4px 30px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(5px)',
          WebkitBackdropFilter: 'blur(5px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
        }}
      >
        <img
          src={image}
          width={props?.width}
          height={props?.height}
          alt="loadingImage"
          className="loadingImage d-block"
        />
        <label className="d-block mx-auto mt-2" style={{ fontWeight: 'bold' }}>
          {props?.caption}
        </label>
      </div>
    </div>
  )
}

Loading.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  accentColor: PropTypes.string,
  caption: PropTypes.string,
  isLoading: PropTypes.bool,
}

Loading.defaultProps = {
  width: 80,
  height: 80,
  accentColor: 'white',
}

export default Loading
